// Counts one page view per client-side navigation. Sits beside ScrollToTop in
// main.jsx so it covers both brands and every route.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics.js';

export default function PageView() {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
